module.exports = __webpack_public_path__ + "static/media/PE.97ca9bae.svg";